/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * CLIENT-INDICATED FINANCIAL RANGES (v1_646).
 *
 * Two single-select bands the client picks at the pre-screening step: annual
 * revenue and total assets, in USD. They are what the CLIENT INDICATES, not a
 * verified figure, so every surface that shows them carries the "client
 * indicated" label and they never read as evidenced numbers. Stored under
 * collected_data.financialRanges { annualRevenue, totalAssets, indicated,
 * indicatedAt } and carried across rebuilds.
 *
 * This module is the single source of the band list and their labels, so the
 * pre-screening tick-boxes, the officer panel and every report agree. Pure.
 */

export const FINANCIAL_BANDS = Object.freeze([
  { value: 'lt_250k', label: 'Under $250,000' },
  { value: '250k_500k', label: '$250,000 to $500,000' },
  { value: '500k_1m', label: '$500,000 to $1 million' },
  { value: '1m_5m', label: '$1 million to $5 million' },
  { value: '5m_10m', label: '$5 million to $10 million' },
  { value: 'gt_10m', label: 'Over $10 million' },
]);

export function bandLabel(value) {
  const b = FINANCIAL_BANDS.find((x) => x.value === value);
  return b ? b.label : '';
}

// Rows for a panel or report, each explicitly labelled "client indicated" so it
// can never be mistaken for a verified figure. Returns only the bands actually
// indicated (0, 1 or 2 rows). Tolerates missing/garbage input.
export function financialRangeRows(financialRanges) {
  const fr = financialRanges && typeof financialRanges === 'object' ? financialRanges : {};
  const rows = [];
  if (bandLabel(fr.annualRevenue)) rows.push({ key: 'annualRevenue', label: 'Annual revenue (client indicated)', value: bandLabel(fr.annualRevenue) });
  if (bandLabel(fr.totalAssets)) rows.push({ key: 'totalAssets', label: 'Total assets (client indicated)', value: bandLabel(fr.totalAssets) });
  return rows;
}
